export interface RegraLoteRoteirizacao {
  inicio: string;
  fim: string;
  maxComandas: number;
}

export const REGRAS_LOTE_ROTEIRIZACAO_DEFAULT: RegraLoteRoteirizacao[] = [
  { inicio: "17:00", fim: "19:30", maxComandas: 1 },
  { inicio: "19:30", fim: "22:00", maxComandas: 2 },
  { inicio: "22:00", fim: "23:45", maxComandas: 1 },
];

export interface Loja {
  id: number;
  nome: string;
  endereco: string;
  telefone: string;
  cnpj: string;
  usaIntegracaoPedidos?: boolean;
  roteirizacaoAutomaticaAtiva?: boolean;
  distanciaMaximaCasamentoKm?: number;
  aguardarCasamentoMinutos?: number;
  lojaLatitude?: number | null;
  lojaLongitude?: number | null;
  regrasLoteRoteirizacao?: RegraLoteRoteirizacao[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface LojaFilters {
  nome?: string;
  endereco?: string;
  telefone?: string;
  cnpj?: string;
  page?: number;
  limit?: number;
}
